<template>
	<div class="container">
		<div class="main_box">
			<!--块1-->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_1_main">
					<div class="left_box">
						<div
							v-for="(value, index) in navList"
							:key="index"
							class="left_el"
							v-if="value.title != $t('footer.text6')"
						>
							<div class="tit" @click="oneNavClick(value)">{{ value.title }}</div>
							<div v-if="value.title != $t('footer.text7')">
								<div class="txt" v-for="(value2, index2) in value.children" :key="index2" @click="oneNavClick(value2, true)">{{ value2.title }}</div>
							</div>
							<div v-else>
								<div class="txt" v-for="(value2, index2) in value.children.cate_list" :key="index2" @click="oneNavClick2(value2)">{{ value2.title }}</div>
							</div>
						</div>
					</div>
					<div class="right_box">
						<img src="../../assets/img_public/logo.png" @click="goIndex" />
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_2_main">
					<div class="left_box">
						<div class="left_el" style="font-size: 16px;">
						  <van-icon name="phone-o" size="18px" style="top: 4px;" />&nbsp;Call Tests:&nbsp;
							<!-- 400 606 1166&ensp;|&ensp;010-69391166
						    &ensp;&ensp;&ensp;&ensp; -->
							+ 86-10-69390616
						</div>
						<!-- <div class="left_el" style="font-size: 16px;">
						  <van-icon name="phone-o" size="18px" style="top: 4px;" />&nbsp;Call Tests:&nbsp;
							010-69390623&ensp;|&ensp;0312-6779810
							&ensp;&ensp;&ensp;&ensp;
						  </div> -->
						<div class="left_el" style="font-size: 16px;">
							<van-icon name="envelop-o" size="18px" style="top: 4px;" />&nbsp;
							  <a href="mailto:Business@CorDx.com">Business@CorDx.com</a>
						</div>
						<div class="left_el">
							{{ $t('footer.text1') }}<span style="font-size: 16px;">5900 Windward Pkwy. Alpharetta, GA 30005 USA</span>
						</div>
						<div class="left_el">
							{{ $t('footer.text2') }}
						</div>
						<div class="left_el">
							{{ $t('footer.text3') }}
						</div>
					</div>
					<div v-if="lang == 'cn'" class="right_box">
						<div class="code_el">
							<img src="../../assets/img_public/icon_code_2.webp" />
							<div class="tit">库尔医疗精灵</div>
						</div>
						<div class="code_el">
							<img src="../../assets/img_public/icon_code_1.webp" />
							<div class="tit">库尔先锋</div>
						</div>
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_3_main">
					<div class="top_box">
						<div class="tit">{{ $t('footer.text4') }}</div>
						<div class="top_el">
							<a href="https://cordx.com/" target="_blank">
								<img src="../../assets/img_public/link_7.png" style="width: 100px;" />
							</a>
						</div>
						<div class="top_el">
							<a href="https://www.abiores.com/en/" target="_blank">
								<img src="../../assets/img_public/web_2.png" />
							</a>
						</div>
						<div class="top_el">
							<a href="https://bonore.com/" target="_blank">
								<img src="../../assets/img_public/bonore.png" />
							</a>
						</div>
						<div class="top_el">
							<a href="https://ucreagent.com/" target="_blank">
								<img src="../../assets/img_public/ucreagent.png" />
							</a>
						</div>
						<div class="top_el">
							<a href="https://cupet.com/" target="_blank">
								<img src="../../assets/img_public/web_5.png" />
							</a>
						</div>
					</div>
					<div class="bot_box">
						{{ $t('footer.text5') }}&ensp;|&ensp;
						<a href="https://beian.miit.gov.cn/" target="_blank">京ICP备18005116号-1</a>
						<a v-if="false" href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank">公安备案号：11011102001223</a>
						<a v-if="false" href="https://backapi.coretests.com/vancheerfile/Images/2022-00222.jpg" target="_blank">药品医疗器械网络信息服务备案编号：（京）网药械信息备字（2022）第00222号</a>
					</div>
				</div>
			</div>
			<!--块3-->
		</div>
	</div>
</template>

<script>
export default {
	components:{
		//
	},
	data() {
		return {
			navList: [],
			lang: sessionStorage.getItem('lang')
		}
	},
	created(){
		let that = this;
		if(sessionStorage.getItem('navList')) {
			that.navList = JSON.parse(sessionStorage.getItem('navList'));
		}
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		oneNavClick2(value) {
			let that = this;
			if(this.$route.path != '/product-list.html') {
				that.$router.push({ path: '/product-list.html', query: { cate_ids: value.id, } });
			}else {
				that.$router.push({ path: '/product-list.html', query: { cate_ids: value.id, } });
				setTimeout(() => {
					window.location.reload();
				}, 300);
			}
		},
		//一级导航点击
		oneNavClick(value, value2) {
			let that = this;
			if(that.$route.fullPath != value.url) {
				if(value.route == 'JobList') {
					if(that.$route.name === value.route) {
						that.$router.push({ path: '/job/'+value.url });
						window.location.reload();
					}else {
						that.$router.push({ path: '/job/'+value.url });
					}
				}else {
					if(value2) {
						if(that.$route.name === value.route) {
							that.$router.push({ path: value.url, });
							window.location.reload();
						}else {
							if(that.$route.path != value.url) {
								that.$router.push({ path: value.url, });
							}
						}
					}else {
						that.$router.push({ path: value.url });
					}
				}
			}else {
				window.location.reload();
			}
		},
		//点击首页
		goIndex() {
			if(this.$route.path != '/') {
				this.$router.push({ path: '/' });
			}else {
				window.location.reload();
			}
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//块3
	.block_3{
		padding: 20px 0 30px 0;
		background-color: rgba(247, 246, 249, 1);
		.block_3_main{
			width: 1264px;
			margin: 0 auto;
			.bot_box{
				padding-top: 4px;
				a{
					color: #000000;
				}
				a:hover{
					color: #A50073;
				}
			}
			.top_box{
				display: flex;
				align-items: center;
				.tit{
					display: inline-block;
					margin-right: 20px;
					font-size: 16px;
					position: relative;
				}
				.top_el{
					display: inline-block;
					margin-right: 40px;
					img{
						width: 120px;
						cursor: pointer;
					}
					a{
						display: inline-block;
						height: 100%;
					}
				}
			}
		}
	}
	//块2
	.block_2{
		padding: 40px 0 20px 0;
		.block_2_main{
			width: 1264px;
			margin: 0 auto;
			display: flex;
			.left_box{
				flex: 1;
				.left_el{
					padding-bottom: 10px;
					a{
						color: #000000;
					}
					a:hover{
						color: #A50073;
					}
				}
			}
			.right_box{
				width: auto;
				.code_el{
					display: inline-block;
					margin-left: 40px;
					img{
						width: 100px;
					}
					.tit{
						padding-top: 8px;
						font-size: 12px;
						text-align: center;
					}
				}
			}
		}
	}
	//块1
	.block_1{
		width: 100%;
		padding: 80px 0 70px 0;
		border-top: 1px solid #999999;
		border-bottom: 1px solid rgba(153, 153, 153, 0.2);
		.block_1_main{
			width: 1264px;
			margin: 0 auto;
			display: flex;
			.left_box{
				flex: 2;
				display: flex;
				.left_el{
					flex: 1;
					cursor: pointer;
					.tit{
						padding-bottom: 16px;
						font-size: 20px;
						font-weight: bold;
					}
					.txt{
						padding-bottom: 6px;
						font-size: 16px;
					}
				}
			}
			.right_box{
				width: 140px;
				text-align: right;
				img{
					width: 140px;
					cursor: pointer;
				}
			}
		}
	}
}
</style>